import React from 'react';
const testimonials = [{
  initials: 'MR',
  quote: 'Ho organizzato tutta la stagione in una sola serata. Ora ogni allenamento ha un obiettivo chiaro.',
  name: 'Marco R.',
  role: 'Allenatore Giovanile · Milano'
}, {
  initials: 'AP',
  quote: 'I miei giocatori migliorano più velocemente perché finalmente seguono una progressione logica.',
  name: 'Andrea P.',
  role: 'Allenatore U15 · Bologna'
}, {
  initials: 'LT',
  quote: 'Non passo più ore su YouTube a cercare esercizi. Apro Basket Pronto e ho già tutto.',
  name: 'Luca T.',
  role: 'Istruttore MiniBasket · Roma'
}, {
  initials: 'SF',
  quote: 'Le schede di valutazione hanno cambiato i colloqui con le famiglie. Ora parlo con i numeri.',
  name: 'Stefano F.',
  role: 'Capo Allenatore · Torino'
}, {
  initials: 'GC',
  quote: "In due mesi il gruppo è cresciuto più che nell'intera scorsa stagione.",
  name: 'Giulia C.',
  role: 'Allenatrice U13 femminile · Firenze'
}, {
  initials: 'DR',
  quote: "Il Kit Tattico Pro mi ha salvato in tre time-out decisivi quest'anno.",
  name: 'Davide R.',
  role: 'Coach Senior · Napoli'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-229">
      <div className="max-w-5xl mx-auto" data-id="element-230">
        <div className="text-center mb-12" data-id="element-231">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-232">
            Cosa dicono gli <span className="text-[#FF6B00]" data-id="element-233">allenatori</span>
          </h2>
          <p className="text-[#5A5A66] text-base font-bold" data-id="element-234">
            ⭐⭐⭐⭐⭐ 4.9/5 · +500 allenatori in tutta Italia
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-235">
          {testimonials.map((t, i) => <div key={i} className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 flex flex-col shadow-sm" data-id="element-236">
              <div className="flex items-center gap-3 mb-4" data-id="element-237">
                <div className="w-10 h-10 rounded-full bg-[#FF6B00] flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-238">
                  {t.initials}
                </div>
                <div className="text-[#FFD700] text-sm" data-id="element-239">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-[#0A0A0A] text-sm font-medium italic leading-relaxed mb-6 flex-1" data-id="element-240">
                "{t.quote}"
              </p>
              <div data-id="element-241">
                <p className="text-[#0A0A0A] font-black text-sm" data-id="element-242">{t.name}</p>
                <p className="text-[#5A5A66] text-xs font-semibold mt-0.5" data-id="element-243">
                  {t.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}